import {
  HOUSE_CONTENTS_ABOUT_STEP,
  HOUSE_CONTENTS_INTRO_STEP,
  HOUSE_CONTENTS_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/HouseContents";

import { FormStates } from "Store/priceCalculation/priceCalculationInterfaces";
import { mapInjuriesToForm } from "Store/priceCalculation/productMappers/common/injuriesMapper";
import { booleanToFormBoolean } from "Utils/formUtils";
import { isDefined } from "Utils/functions";

export function mapFromCommerceHouseContents(
  data: Record<string, any>,
): FormStates {
  return {
    [HOUSE_CONTENTS_INTRO_STEP.id]: {
      addressSameAsHomeAddress: booleanToFormBoolean(
        data.addressSameAsHomeAddress,
      ),
      postNumber: data.address?.zipCode ?? "",
      city: data.address?.city ?? "",
      validPostNumber: !!data.address?.city,
      fullRental: isDefined(data.fullRental)
        ? booleanToFormBoolean(data.fullRental)
        : undefined,
    },

    [HOUSE_CONTENTS_ABOUT_STEP.id]: {
      coverageAmount: data.coverageAmount,
      fireResistantBuildingMaterial: booleanToFormBoolean(
        data.fireResistantBuildingMaterial,
      ),
      ...mapInjuriesToForm(data.damageCountRecentYears, data.yearOfLastDamage),
    },

    [HOUSE_CONTENTS_PRICE_STEP.id]: {
      hasBurglarAlarm: data.hasBurglarAlarm ?? false,
      hasFireAlarm: data.hasFireAlarm ?? false,
      deductible: isDefined(data.priceSpecifications.deductible.code)
        ? String(data.priceSpecifications.deductible.code)
        : "",
      coverage: data.coverageGroup,
    },
  };
}
